import { Trophy, Fish, Users, LineChart } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const Card = ({ className = "", children, delay, testid }) => (
  <Reveal delay={delay} className={className}>
    <div data-testid={testid}
      className="group relative h-full overflow-hidden rounded-3xl border border-cyan-400/12 bg-[#0F1829] hover:border-cyan-400/40 transition-colors duration-500">
      {children}
    </div>
  </Reveal>
);

const PhotoCard = ({ img, alt, icon: Icon, title, text }) => (
  <>
    <img src={img} alt={alt} loading="lazy"
      className="absolute inset-0 h-full w-full object-cover opacity-70 group-hover:scale-105 group-hover:opacity-90 transition-[transform,opacity] duration-[1200ms]" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#050911] via-[#050911]/60 to-transparent" />
    <div className="relative flex h-full flex-col justify-end p-6 sm:p-8">
      <Icon className="mb-4 h-7 w-7 text-[#00E5FF]" />
      <h3 className="font-display text-2xl sm:text-3xl font-extrabold uppercase text-white">{title}</h3>
      <p className="mt-2 max-w-md text-sm sm:text-base text-slate-300">{text}</p>
    </div>
  </>
);

const TextCard = ({ icon: Icon, n, title, text }) => (
  <div className="flex h-full flex-col justify-between p-6 sm:p-8">
    <div className="flex items-center justify-between">
      <Icon className="h-7 w-7 text-[#F59E0B]" />
      <span className="font-mono text-xs text-slate-400">{n}</span>
    </div>
    <div className="mt-10">
      <h3 className="font-display text-2xl sm:text-3xl font-extrabold uppercase text-white">{title}</h3>
      <p className="mt-2 text-sm sm:text-base text-slate-300">{text}</p>
    </div>
  </div>
);

export const Features = () => (
  <section id="features" className="relative mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-36">
    <SectionHead over="// 01 — The app" title={<>Fishing, now<br />with a scoreboard.</>}
      sub="Everything you need to turn weekend trips into a season-long rivalry." />
    <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:auto-rows-[300px]">
      <Card className="md:col-span-8 md:row-span-2 min-h-[380px]" testid="feature-leagues">
        <PhotoCard img="/img/boat.jpg" alt="Anglers on a boat" icon={Trophy} title="Leagues & seasons"
          text="Create or join leagues with friends, clubs or your whole region and battle it out across a full season." />
      </Card>
      <Card className="md:col-span-4" delay={0.1} testid="feature-catch-log">
        <TextCard icon={Fish} n="02" title="Catch logging" text="Snap, log and submit your catch in seconds, right from the water." />
      </Card>
      <Card className="md:col-span-4" delay={0.2} testid="feature-leaderboards">
        <TextCard icon={LineChart} n="03" title="Live leaderboards" text="Watch the standings shift with every fish landed." />
      </Card>
      <Card className="md:col-span-5 min-h-[300px]" delay={0.1} testid="feature-community">
        <TextCard icon={Users} n="04" title="Rivals & crews" text="Follow anglers, build a crew and settle who really fishes best." />
      </Card>
      <Card className="md:col-span-7 min-h-[300px]" delay={0.2} testid="feature-water">
        <PhotoCard img="/img/sunset.jpg" alt="Angler at sunset on a lake" icon={Fish} title="Every water counts"
          text="Lakes, rivers or offshore — your catches count wherever you fish." />
      </Card>
    </div>
  </section>
);
